<template>
  <div class="wineclub-container container">
    <section class="club-section">
      <ClubContainer
        :club="club"
        single
      />
    </section>
  </div>
</template>

<script>
  import ClubContainer from './components/ClubContainer'
  import { pageMixin, asyncLoader } from './mixins/wineclub'

  export default {
    name: 'page-content-type-wine_club',
    mixins: [
      pageMixin
    ],
    components: {
      ClubContainer
    },
    asyncData: (args) => {
      return asyncLoader(args)
        // .then(item => {
        //   if ( typeof window !== 'undefined' && item) {
        //     document.title = item.title
        //   }
        // })
    },
  }

</script>


<style scoped lang="scss">
::v-deep .wine-club-list {
  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  h1 {
    font-size: 1.6em;
    &.text-center {
      text-align: center;
    }
  }

  h2 {
    font-size: 1.4em;
  }

  h3 {
    font-size: 1.1em;
  }

  .btn {
    &.btn-small {
      padding: .3em 1em;
      font-size: .8em;
    }
  }
}
</style>
